module.exports = __webpack_public_path__ + "static/media/logo-pm-india.06518df8.png";